import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntity, updateEntity, createEntity, reset } from './report-daily-vehicle.reducer';
import { IReportDailyVehicle } from 'app/shared/model/report-daily-vehicle.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ReportDailyVehicleUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const reportDailyVehicleEntity = useAppSelector(state => state.reportDailyVehicle.entity);
  const loading = useAppSelector(state => state.reportDailyVehicle.loading);
  const updating = useAppSelector(state => state.reportDailyVehicle.updating);
  const updateSuccess = useAppSelector(state => state.reportDailyVehicle.updateSuccess);

  const handleClose = () => {
    props.history.push('/report-daily-vehicle' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...reportDailyVehicleEntity,
      ...values,
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
      user: users.find(it => it.id.toString() === values.userId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...reportDailyVehicleEntity,
          created: convertDateTimeFromServer(reportDailyVehicleEntity.created),
          truckImplementId: reportDailyVehicleEntity?.truckImplement?.id,
          companyId: reportDailyVehicleEntity?.company?.id,
          userId: reportDailyVehicleEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.reportDailyVehicle.home.createOrEditLabel" data-cy="ReportDailyVehicleCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.reportDailyVehicle.home.createOrEditLabel">Create or edit a ReportDailyVehicle</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="report-daily-vehicle-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.createdDate')}
                id="report-daily-vehicle-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.totalAlerts')}
                id="report-daily-vehicle-totalAlerts"
                name="totalAlerts"
                data-cy="totalAlerts"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.totalSensorAlerts')}
                id="report-daily-vehicle-totalSensorAlerts"
                name="totalSensorAlerts"
                data-cy="totalSensorAlerts"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.totalFenceCircleAlerts')}
                id="report-daily-vehicle-totalFenceCircleAlerts"
                name="totalFenceCircleAlerts"
                data-cy="totalFenceCircleAlerts"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.uptime')}
                id="report-daily-vehicle-uptime"
                name="uptime"
                data-cy="uptime"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.downtime')}
                id="report-daily-vehicle-idletime"
                name="idletime"
                data-cy="idletime"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.odometer')}
                id="report-daily-vehicle-odometer"
                name="odometer"
                data-cy="odometer"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.travelledDistance')}
                id="report-daily-vehicle-travelledDistance"
                name="travelledDistance"
                data-cy="travelledDistance"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.maximumSpeed')}
                id="report-daily-vehicle-maximumSpeed"
                name="maximumSpeed"
                data-cy="maximumSpeed"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.minimumSpeed')}
                id="report-daily-vehicle-minimumSpeed"
                name="minimumSpeed"
                data-cy="minimumSpeed"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.averageSpeed')}
                id="report-daily-vehicle-averageSpeed"
                name="averageSpeed"
                data-cy="averageSpeed"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.maximumLoad')}
                id="report-daily-vehicle-maximumLoad"
                name="maximumLoad"
                data-cy="maximumLoad"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.minimumLoad')}
                id="report-daily-vehicle-minimumLoad"
                name="minimumLoad"
                data-cy="minimumLoad"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.averageLoad')}
                id="report-daily-vehicle-averageLoad"
                name="averageLoad"
                data-cy="averageLoad"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.absActivations')}
                id="report-daily-vehicle-absActivations"
                name="absActivations"
                data-cy="absActivations"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.rssActivations')}
                id="report-daily-vehicle-rssActivations"
                name="rssActivations"
                data-cy="rssActivations"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.reportDailyVehicle.brakeActivations')}
                id="report-daily-vehicle-brakeActivations"
                name="brakeActivations"
                data-cy="brakeActivations"
                type="text"
              />
              <ValidatedField
                id="report-daily-vehicle-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.reportDailyVehicle.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="report-daily-vehicle-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.reportDailyVehicle.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="report-daily-vehicle-user"
                name="userId"
                data-cy="user"
                label={translate('fleetSenseApp.reportDailyVehicle.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/report-daily-vehicle" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ReportDailyVehicleUpdate;
